module.exports = "https://cdn.realtymogul.com/static/media/1031_Hero.25b8413a.jpg";